var defaultProps = {
  containerProps: {},
  autoFocus: false,
  className: '',
  disabled: false,
  name: '',
  id: null,
  maxLength: null,
  minLength: 0,
  placeholder: '',
  onClick: function onClick() {
    return null;
  },
  onChange: function onChange() {
    return null;
  },
  onFocus: function onFocus() {
    return null;
  },
  onBlur: function onBlur() {
    return null;
  },
  onKeyUp: function onKeyUp() {
    return null;
  },
  onKeyDown: function onKeyDown() {
    return null;
  },
  onPaste: function onPaste() {
    return null;
  },
  value: '',
  hasError: false,
  required: false,
  readOnly: false,
  resize: 'vertical',
  innerRef: null,
  ariaLabel: 'Enter text',
  ariaAutocomplete: 'none',
  role: 'textbox',
  characterLimitCounter: 0,
  rows: 3,
  errorLimit: 'Please limit your entry to',
  tabIndex: ''
};

export { defaultProps };
//# sourceMappingURL=defaultProps.js.map
